import React from 'react';

export const SearchIcon = ({ color }: { color: string }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16.468" height="16.554" viewBox="0 0 16.468 16.554">
      <path
        data-name="App Navigation icons-search"
        d="M23.672 23.221a7.221 7.221 0 1 0-5.611 2.6h.061a7.217 7.217 0 0 0 4.621-1.673l3.5 3.5a.655.655 0 0 0 .461.193h.007a.667.667 0 0 0 .466-.191.656.656 0 0 0 .005-.926zM18.128 24.5a5.891 5.891 0 1 1 4.166-1.726 5.891 5.891 0 0 1-4.166 1.726z"
        transform="translate(-10.901 -11.291)"
        style={{ fill: color }}
      />
    </svg>
  );
};
